import { render, staticRenderFns } from "./AcoesExportarResultado.vue?vue&type=template&id=0fd5614b&scoped=true"
import script from "./AcoesExportarResultado.vue?vue&type=script&lang=js"
export * from "./AcoesExportarResultado.vue?vue&type=script&lang=js"
import style0 from "./AcoesExportarResultado.vue?vue&type=style&index=0&id=0fd5614b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5614b",
  null
  
)

export default component.exports